import { switchAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { cssVar } from '@chakra-ui/theme-tools';
import { BorderWidths, Colors, Radii, Shadows } from '../../types';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);

const $width = cssVar('switch-track-width');
const $height = cssVar('switch-track-height');

const baseStyle = definePartsStyle({
  group: {
    display: 'inline-flex',
    alignSelf: 'stretch',
  },
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: 'inherit',
  },
  thumb: {
    bg: Colors.TEXT_ON_PRIMARY,
    boxShadow: Shadows.XS,
    outline: '1px solid',
    outlineColor: Colors.BORDER_ELEVATED,
    transitionDuration: 'ultra-fast',
    transitionTimingFunction: 'ease-in',
    boxSize: 'calc(var(--switch-track-height) - 2px)',
    _disabled: {
      bg: Colors.TEXT_DISABLED,
      boxShadow: Shadows.NONE,
    },
  },
  track: {
    '--switch-bg': `colors.${Colors.SURFACE_NEUTRAL_MUTED}`,
    boxShadow: Shadows.INNER,
    borderRadius: Radii.FULL,
    borderWidth: BorderWidths.XS,
    borderColor: Colors.BORDER_INPUT,
    boxSizing: 'border-box',
    padding: '0px',
    _hover: {
      '--switch-bg': `colors.${Colors.ICON_NEUTRAL}`,
      bg: Colors.ICON_NEUTRAL,
    },
    _active: {
      '--switch-bg': `colors.${Colors.SURFACE_NEUTRAL}`,
      bg: Colors.SURFACE_NEUTRAL,
    },
    _disabled: {
      bg: Colors.TRANSPARENT,
      borderColor: Colors.SURFACE_DISABLED,
      _hover: {
        bg: Colors.TRANSPARENT,
        borderColor: Colors.SURFACE_DISABLED,
      },
    },
    _checked: {
      '--switch-bg': `colors.${Colors.SURFACE_PRIMARY}`,
      bg: Colors.SURFACE_PRIMARY,
      borderColor: Colors.BORDER_ELEVATED,
      _hover: {
        '--switch-bg': `colors.${Colors.SURFACE_PRIMARY_HOVER}`,
        bg: Colors.SURFACE_PRIMARY_HOVER,
      },
      _active: {
        bg: Colors.SURFACE_PRIMARY_ACTIVE,
      },
      _disabled: {
        '--switch-bg': `colors.${Colors.SURFACE_DISABLED}`,
      },
    },
    _focusVisible: {
      outline: '2px solid',
      outlineColor: Colors.BORDER_FOCUS,
      outlineOffset: '2px',
      boxShadow: 'none',
    },
  },
});
const sizes = {
  sm: definePartsStyle({
    container: {
      [$width.variable]: 'sizes.7',
      [$height.variable]: 'sizes.4',
    },
  }),
  md: definePartsStyle({
    container: {
      [$width.variable]: 'sizes.8',
      [$height.variable]: 'sizes.5',
    },
  }),
  lg: definePartsStyle({
    container: {
      [$width.variable]: 'sizes.10',
      [$height.variable]: 'sizes.6',
    },
  }),
};

export const Switch = defineMultiStyleConfig({
  baseStyle,
  sizes,
  defaultProps: {
    size: 'md',
    colorScheme: 'brand',
  },
});
